import React from 'react';

import BackgroundImage from '../images/background/banner_MyAccount.png'; 
import Banner from './Banner';

import { Clear } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { Typography, IconButton } from '@material-ui/core';

const styles = theme => ({
  banner: {
    backgroundImage:`url(${BackgroundImage})`, 
    backgroundSize: 'cover', 
    height: 64,
  },
  defaultText: {
    color: '#FFFFFF',
    fontWeight: 400,
    fontSize: 16,
  },
  button: {
    color: 'white',
    marginRight: 8,
  },
});

class AlertBanner extends React.Component {
  
  render() {
    const {
      dismissAlert,
      user,
      alert,
      classes,
    } = this.props;

    return (
      <Banner
        center
        paperStyle={classes.banner}
        actions={[
          <IconButton
            key={alert.id}
            className={classes.button}
            aria-label="dismiss alert"
            onClick={() => dismissAlert(user.id, alert.id)}
          >
            <Clear />
          </IconButton>
        ]}
      >
        <Typography className={classes.defaultText}>
          {alert.message}
        </Typography>
      </Banner>
    )
  }
}

export default withStyles(styles)(AlertBanner);


// WEBPACK FOOTER //
// ./src/components/AlertBanner.js